// extracted by mini-css-extract-plugin
export default {"tit":"App_tit__b3w-3","introDiv":"App_introDiv__ZwlHD","logo":"App_logo__f1YyP","introDivFade":"App_introDivFade__dKZBy","fade-out":"App_fade-out__oM7aA"};